<template>
  <lateral-modal
    :title="$t('FILTERS')"
    @close="closeModal"
  >
    <template slot="extraAction">
      <div
        class="Link Link--action"
        @click="reset"
        v-t.preserve="{ path: 'ACTION_CLEAR' }"
      ></div>
    </template>
    <template slot="content">
      <form
        action=""
        class="Form"
      >

        <div class="input--block input--block--margin input--block--padded">
          <label
            for=""
            class="form--label"
          > {{$t('customer_onboarding_header').toUpperCase()}}</label>
          <div class="mutiselect-filter">
            <multi-select-input
              :value="customerCreationType.id"
              :options="customerCreationTypes"
              emitFullValue
              @inputSelected="setField('customerCreationType', $event)"
              :customLabelField="'code'"
              translateLabel
              :translateLabelAdditionalKey="'customer_onboarding_type__'"
              :placeholder="$t('customer_onboarding_header')"
            />
          </div>
        </div>

      </form>
    </template>
    <template slot="footer">
      <button
        class="Button Button--primary flex-grow-1"
        @click.prevent="setFilters"
        v-t.preserve="{ path: 'ACTION_FILTER' }"
      ></button>
    </template>
  </lateral-modal>
</template>

<script>
import _modalHandlerMixin from '@/components/Commons/_mixins/_modalHandlerMixin'
import MultiSelectInput from '@/components/Commons/Forms/MultiSelectInput'
import LateralModal from '@/components/Commons/Modals/LateralModal'

export default {
  name: 'CustomerFiltersModal',
  mixins: [_modalHandlerMixin],
  components: {
    MultiSelectInput,
    LateralModal
  },
  data () {
    return {
      customerCreationType: ''
    }
  },
  computed: {
    isSubmitting () {
      return false
    },
    customerCreationTypes () {
      return this.$store.getters['ConfigStore/privateConfig'].customer_creation_types
    },
    customerFilters () {
      return this.$store.getters['CustomersStore/filters']
    }
  },
  methods: {
    setField (fieldName, value) {
      this[fieldName] = value
    },
    reset () {
      this.customerCreationType = ''
      this.$emit('resetCustomerFilters')
      this.closeModal()
    },
    setFilters () {
      const filters = {
        'creationType.code': this.customerCreationType.code
      }
      this.$store.dispatch('CustomersStore/clearCustomers')
      this.$store.dispatch('CustomersStore/addCustomerFilters', filters)
      this.closeModal()
    },
    _initializeFilters () {
      if (this.customerFilters) {
        if (this.customerFilters['creationType.code']) {
          const creationTypeFilter = this.customerCreationTypes.find(el => el.code === this.customerFilters['creationType.code'])
          this.customerCreationType = { ...creationTypeFilter }
        }
      }
    }

  },
  created () {
    this._initializeFilters()
  },
  beforeRouteUpdate (to, from, next) {
    this.closeModal()
    next()
  }
}
</script>

<style scoped>
.ModalBox,
.ModalBox-footer {
  width: 415px;
}
.Link {
  cursor: pointer;
}

.Radiobutton {
  border-radius: 15px;
}
.Radiobutton--selected:after {
  border-radius: 15px;
  width: 8px;
  height: 8px;
  left: 3px;
  top: 3px;
}
.custom-category-option {
  font-weight: 300;
  font-size: 15px;
  position: relative;
  height: 34px;
}
.custom-category-option.is-parent {
  font-weight: 500;
}
.custom-category-option.is-parent .category-name {
  margin-top: 8px;
}
.custom-category-option .parent-category-name {
  position: absolute;
  font-size: 11px;
  top: 0px;
}
.custom-category-option .category-name {
  position: absolute;
  margin-top: 15px;
}

.custom-category-selected {
  font-weight: 300;
  font-size: 15px;
  position: relative;
}
.custom-category-selected.is-parent {
  font-weight: 500;
}
.custom-category-selected.is-parent .category-name {
  margin-top: 0px;
}
.custom-category-selected .parent-category-name {
  position: absolute;
  font-size: 11px;
  top: -8px;
}
.custom-category-selected .category-name {
  position: absolute;
  margin-top: 6px;
  white-space: nowrap;
  overflow: hidden;
  width: 100%;
  text-overflow: ellipsis;
}
</style>
